import { render, staticRenderFns } from "./BrokerAccounts.vue?vue&type=template&id=accf7e38"
import script from "./BrokerAccounts.vue?vue&type=script&lang=js"
export * from "./BrokerAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports